{
  "version": 1,
  "asset_id": "d6eb8730-cb4a-4246-a6dd-0ad8765ff736",
  "project_id": "7948fbe6-b4e3-485f-995c-f8f53bd7ab6b",
  "url": "/__l5e/assets-v1/d6eb8730-cb4a-4246-a6dd-0ad8765ff736/arwen-spa-suite.png",
  "r2_key": "a/v1/7948fbe6-b4e3-485f-995c-f8f53bd7ab6b/d6eb8730-cb4a-4246-a6dd-0ad8765ff736/arwen-spa-suite.png",
  "original_filename": "arwen-spa-suite.png",
  "size": 2986498,
  "content_type": "image/png",
  "created_at": "2026-07-05T03:31:04Z"
}
